import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from '@tanstack/react-router';
import React from 'react';

export const WrappedRouterLink = React.forwardRef<
  HTMLAnchorElement,
  Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }
>((props, ref) => {
  const { href, ...other } = props;
  return <RouterLink ref={ref} to={href} {...other} />;
});
